<mat-card class="screenshot-main-card" id="screenshotViewerSection">
  <div class="row ss-border-row">
    <div class="col s12 m6">
      <h2 *ngIf="!(isDownloadAll || isDeleteAll)">
        Screenshots
      </h2>
    </div>

    <!-- <div class="col s12 m4" style="display: flex;justify-content:flex-end;align-items: center;">
      <span *ngIf="userSSList && userSSList.length">
        <button mat-raised-button class="supersee-action-btn download" *ngIf="!isDeleteAll"
          (click)="!isDownloadAll ? enableSelection('download'): downloadAll()">
          <span class="material-symbols-outlined">
            download
          </span>
          Download <span *ngIf="isDownloadAll" style="margin-left: 2px;"> All Screenshots</span>
        </button>
      </span>

      <span *ngIf="userSSList && userSSList.length">
        <button mat-raised-button class="supersee-action-btn delete" *ngIf="!isDownloadAll"
          (click)="!isDeleteAll ? enableSelection('delete') : removeAllImages()">
          <span class="material-symbols-outlined">
            delete
          </span>
          Delete <span *ngIf="isDeleteAll" style="margin-left: 2px;"> All Screenshots</span>
        </button>
      </span>

      <span *ngIf="isDownloadAll || isDeleteAll">
        <button mat-raised-button class="supersee-action-btn" (click)="enableSelection()">
          <span class="material-symbols-outlined">
            cancel
          </span>
          Cancel
        </button>
      </span>

    </div> -->

    <div class="col s12 m6 ss-datepicker-contain">
      <mat-form-field class="date-range-picker-form-field ">
        <mat-date-range-input [rangePicker]="picker" [min]="minDate" [max]="maxDate">
          <input matStartDate [value]="startDate" placeholder="Start date" (dateChange)="onStartDateChange($event)" />
          <input matEndDate [value]="endDate" placeholder="End date" (dateChange)="onEndDateChange($event)" />
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
    </div>

  </div>
  <div class="screenshot-time-hint" *ngIf="regionHint" role="note">
    <mat-icon class="hint-icon" fontSet="material-symbols-outlined">public</mat-icon>
    <span class="hint-text">{{ regionHint }}</span>
  </div>
  <div class="container-fluid">
    <div *ngIf="loading">
      <div class="row">
        <div class="col s12 m6 l3" *ngFor="let item of [].constructor(8)">
          <ngx-skeleton-loader style="margin: 20px 0px; width: 100%"
            [theme]="{ 'border-radius': '2', height: '280px', margin: '5px' }"></ngx-skeleton-loader>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="userSSList && userSSList.length;">
      <div class="col s12 m6 l6 my-3 screenshot-card" *ngFor="let ss of userSSList; let i = index">
        <ng-container>
          <app-ss-card [image]="ss" [userList]="userList" [isEmployeeProfile]="true" [isAdmin]="isAdmin"
            (imageOpenerEmitter)="onScreenshotCardClick($event)" (deleteScreenShotEmitter)="removeScreenShot($event)"
            (downloadScreenShotEmitter)="downloadScreenShot($event)">
          </app-ss-card>
        </ng-container>
      </div>
    </div>

    <div *ngIf="userSSList && !userSSList.length && !loading">
      <div class="empty_list z-depth-2">
        <img src="../../../assets/images/empty_list.png" alt="empty list image" />
      </div>
      <app-optional-setup-help-links></app-optional-setup-help-links>
    </div>

    <div *ngIf="userSSList && userSSList.length">
      <mat-paginator [length]="totalSS" [pageSize]="pageSize" [pageSizeOptions]="pageOptions" aria-label="Select page"
        (page)="onPageChange($event)" #EmpPaginator>
      </mat-paginator>
    </div>
  </div>
</mat-card>